import * as React from "react";
import { useNavigate } from "react-router-dom";
import { Table } from "react-bootstrap";
import { Chip } from "@mui/material";

export function StatusChip({ statusValue }) {
  const status = statusValue || "BELUM";
  const styles = {
    BELUM: {
      backgroundColor: "#ffffff",
      borderColor: "#cbd5e1",
      color: "#334155",
    },
    ACC: {
      backgroundColor: "#dcfce7",
      borderColor: "#86efac",
      color: "#166534",
    },
    REJECT: {
      backgroundColor: "#fee2e2",
      borderColor: "#fca5a5",
      color: "#991b1b",
    },
  };

  return (
    <Chip
      label={status}
      size="small"
      variant="outlined"
      sx={{
        height: 26,
        minWidth: 78,
        borderRadius: "7px",
        fontSize: "11px",
        fontWeight: 700,
        letterSpacing: 0,
        "& .MuiChip-label": {
          paddingLeft: "10px",
          paddingRight: "10px",
        },
        ...styles[status],
      }}
    />
  );
}

export function ShowTableDaftarUser({ users, selectedId, onSelect }) {
  return (
    <section className="table-panel">
      <Table hover responsive className="data-table">
        <thead>
          <tr>
            <th>Username</th>
            <th>Tipe User</th>
            <th>Cabang</th>
            <th>Surveyor</th>
            <th>Kolektor</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user) => (
            <tr
              key={user._id}
              className={`row-clickable ${user._id === selectedId ? "active-row" : ""}`}
              onClick={() => onSelect(user._id)}
            >
              <td>{user.username}</td>
              <td>
                {user.tipeUser === "SPV/KOMITE" ||
                user.tipeUser === "KOMITE/SPV"
                  ? "SPV"
                  : user.tipeUser}
              </td>
              <td>{user.cabang?.namaCabang || user.cabang || "-"}</td>
              <td>{user.kodeSurveyor?.namaSurveyor || user.kodeSurveyor || "-"}</td>
              <td>{user.kodeKolektor?.namaKolektor || user.kodeKolektor || "-"}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </section>
  );
}

export function ShowTableKolektor({ currentPosts }) {
  const navigate = useNavigate();

  return (
    <section className="table-panel">
      <Table hover responsive className="data-table">
        <thead>
          <tr>
            <th>Kode</th>
            <th>Nama Eksekutor</th>
            <th>Telepon</th>
          </tr>
        </thead>
        <tbody>
          {currentPosts.map((kolektor) => (
            <tr
              key={kolektor._id}
              className="row-clickable"
              onClick={() => navigate(`/kolektor/${kolektor._id}`)}
            >
              <td>{kolektor.kodeKolektor}</td>
              <td>{kolektor.namaKolektor}</td>
              <td>{kolektor.teleponKolektor || "-"}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </section>
  );
}

export function ShowTableSurveyor({ currentPosts }) {
  const navigate = useNavigate();

  return (
    <section className="table-panel">
      <Table hover responsive className="data-table">
        <thead>
          <tr>
            <th>Kode</th>
            <th>Nama Surveyor</th>
            <th>Telepon Surveyor</th>
            <th>Jenis Surveyor</th>
            <th>Head Surveyor</th>
          </tr>
        </thead>
        <tbody>
          {currentPosts.map((surveyor) => (
            <tr
              key={surveyor._id}
              className="row-clickable"
              onClick={() => navigate(`/surveyor/${surveyor._id}`)}
            >
              <td>{surveyor.kodeSurveyor}</td>
              <td>{surveyor.namaSurveyor}</td>
              <td>{surveyor.teleponSurveyor || "-"}</td>
              <td>{surveyor.jenisSurveyor || "-"}</td>
              <td>{surveyor.kodeHeadSurveyor?.namaHeadSurveyor || "-"}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </section>
  );
}

export function ShowTableDaftarPermohonan({ currentPosts }) {
  const navigate = useNavigate();

  return (
    <section className="table-panel">
      <Table hover responsive className="data-table">
        <thead>
          <tr>
            <th>Nama Pemohon</th>
            <th>Surveyor</th>
            <th className="status-column">Status</th>
            <th>Alasan</th>
          </tr>
        </thead>
        <tbody>
          {currentPosts.map((permohonan) => (
            <tr
              key={permohonan._id}
              className="row-clickable"
              onClick={() => navigate(`/namaPemohon/${permohonan._id}`)}
            >
              <td>{permohonan.namaPemohon || "-"}</td>
              <td>
                {permohonan.userId?.kodeSurveyor?.kodeSurveyor
                  ? `${permohonan.userId.kodeSurveyor.kodeSurveyor} - ${permohonan.userId.kodeSurveyor.namaSurveyor}`
                  : permohonan.userId?.username || "-"}
              </td>
              <td className="status-column">
                <StatusChip statusValue={permohonan.status} />
              </td>
              <td>{permohonan.alasan || "-"}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </section>
  );
}

export function ShowTableEntryPermohonan({ currentPosts }) {
  const navigate = useNavigate();

  return (
    <section className="table-panel">
      <Table hover responsive className="data-table">
        <thead>
          <tr>
            <th>Nama Pemohon</th>
            <th>Surveyor</th>
            <th className="status-column">Status</th>
            <th>Alasan</th>
            <th>KTP</th>
            <th>KK</th>
            <th>Penjamin</th>
            <th>Kendaraan</th>
            <th>STNK & BPKB</th>
            <th>Lingkungan</th>
            <th>Lain2</th>
          </tr>
        </thead>
        <tbody>
          {currentPosts.map((permohonan) => (
            <tr
              key={permohonan._id}
              className="row-clickable"
              onClick={() => navigate(`/permohonan/${permohonan._id}`)}
            >
              <td>{permohonan.namaPemohon || "-"}</td>
              <td>
                {permohonan.userId?.kodeSurveyor?.kodeSurveyor
                  ? `${permohonan.userId.kodeSurveyor.kodeSurveyor} - ${permohonan.userId.kodeSurveyor.namaSurveyor}`
                  : permohonan.userId?.username || "-"}
              </td>
              <td className="status-column">
                <StatusChip statusValue={permohonan.status} />
              </td>
              <td>{permohonan.alasan || "-"}</td>
              <td>{permohonan.fotoKtp?.length || 0}</td>
              <td>{permohonan.fotoKk?.length || 0}</td>
              <td>{permohonan.fotoPenjamin?.length || 0}</td>
              <td>{permohonan.fotoKendaraan?.length || 0}</td>
              <td>{permohonan.fotoStnkBpkb?.length || 0}</td>
              <td>{permohonan.fotoLingkungan?.length || 0}</td>
              <td>{permohonan.fotoLainPendukung?.length || 0}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </section>
  );
}

export function ShowTableDataPermohonan({ currentPosts }) {
  const navigate = useNavigate();

  return (
    <section className="table-panel">
      <Table hover responsive className="data-table">
        <thead>
          <tr>
            <th>Nama Pemohon</th>
            <th>Status Dokumen</th>
            <th>No Jual</th>
            <th>Nopol</th>
            <th>Status RO</th>
            <th>Butuh Verifikasi</th>
          </tr>
        </thead>
        <tbody>
          {currentPosts.map((dataPermohonan) => (
            <tr
              key={dataPermohonan._id}
              className="row-clickable"
              onClick={() => navigate(`/dataPermohonan/${dataPermohonan._id}`)}
            >
              <td>{dataPermohonan.namaPemohon?.permohonan?.namaPemohon || "-"}</td>
              <td>{dataPermohonan.statusDokumen || "-"}</td>
              <td>{dataPermohonan.noJual || "-"}</td>
              <td>{dataPermohonan.nopol || "-"}</td>
              <td>{dataPermohonan.statusRo || "-"}</td>
              <td>{dataPermohonan.butuhVerifikasi || "-"}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </section>
  );
}

export function ShowTableDataVerifikasi({ currentPosts }) {
  const navigate = useNavigate();

  return (
    <section className="table-panel">
      <Table hover responsive className="data-table">
        <thead>
          <tr>
            <th>Nama Pemohon</th>
            <th>No Jual</th>
            <th>Nopol</th>
            <th>Foto Kunjungan</th>
            <th>Alasan</th>
          </tr>
        </thead>
        <tbody>
          {currentPosts.map((dataVerifikasi) => (
            <tr
              key={dataVerifikasi._id}
              className="row-clickable"
              onClick={() => navigate(`/dataVerifikasi/${dataVerifikasi._id}`)}
            >
              <td>{dataVerifikasi.admin?.namaPemohon?.permohonan?.namaPemohon || "-"}</td>
              <td>{dataVerifikasi.admin?.noJual || "-"}</td>
              <td>{dataVerifikasi.admin?.nopol || "-"}</td>
              <td>{dataVerifikasi.fotoKunjungan?.length || 0}</td>
              <td>{dataVerifikasi.alasan || "-"}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </section>
  );
}

export function ShowTableValidasiDataVerifikator({ currentPosts }) {
  const navigate = useNavigate();

  return (
    <section className="table-panel">
      <Table hover responsive className="data-table">
        <thead>
          <tr>
            <th>Nama Pemohon</th>
            <th>No Jual</th>
            <th>Nopol</th>
            <th>Alasan Data Verifikasi</th>
            <th>Status Valid</th>
          </tr>
        </thead>
        <tbody>
          {currentPosts.map((validasiDataVerifikator) => (
            <tr
              key={validasiDataVerifikator._id}
              className="row-clickable"
              onClick={() => navigate(`/validasiDataVerifikator/${validasiDataVerifikator._id}`)}
            >
              <td>{validasiDataVerifikator.dataVerifikasi?.admin?.namaPemohon?.permohonan?.namaPemohon || "-"}</td>
              <td>{validasiDataVerifikator.dataVerifikasi?.admin?.noJual || "-"}</td>
              <td>{validasiDataVerifikator.dataVerifikasi?.admin?.nopol || "-"}</td>
              <td>{validasiDataVerifikator.dataVerifikasi?.alasan || "-"}</td>
              <td>{validasiDataVerifikator.statusValid || "-"}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </section>
  );
}

export function ShowTableDaftarKunjungan({ currentPosts }) {
  const navigate = useNavigate();
  const formatSourceType = (value) => {
    if (value === "ENTRY PERMOHONAN") return "DAFTAR PERMOHONAN";
    if (value === "ADMIN VERIFIKATOR") return "VALIDASI DATA VERIFIKATOR";
    return value || "-";
  };

  return (
    <section className="table-panel">
      <Table hover responsive className="data-table">
        <thead>
          <tr>
            <th>Nama Pemohon</th>
            <th>No Jual</th>
            <th>Nopol</th>
            <th>Sumber</th>
            <th>Kolektor</th>
            <th>Tanggal</th>
          </tr>
        </thead>
        <tbody>
          {currentPosts.map((kolektor) => (
            <tr
              key={kolektor._id}
              className="row-clickable"
              onClick={() => navigate(`/daftarKunjungan/${kolektor._id}`)}
            >
              <td>{kolektor.optionNamaPemohon || "-"}</td>
              <td>{kolektor.optionNoJual || "-"}</td>
              <td>{kolektor.optionNopol || "-"}</td>
              <td>{formatSourceType(kolektor.sourceType)}</td>
              <td>{kolektor.userId?.kodeKolektor?.namaKolektor || kolektor.userId?.username || "-"}</td>
              <td>{kolektor.tanggalKunjungan ? new Date(kolektor.tanggalKunjungan).toLocaleDateString("id-ID") : "-"}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </section>
  );
}
